import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import ActionCard, { ActionCardProps } from '../action-card/ActionCard';
import ContactAvatar from '../action-card/ContactAvatar';
import FaqAvatar from '../action-card/FaqAvatar';
import AppBar from '../app-bar/AppBar';
import Breadcrumbs from '../breadcrumbs/Breadcrumbs';

interface Action extends ActionCardProps {
  key: number;
}

const actions: Action[] = [
  {
    actionText: 'FAQ',
    avatar: <FaqAvatar />,
    key: 1,
    to: './faq',
    text: 'Read our frequently asked questions to find the information that most users wonder about.',
    title: 'FAQ',
  },
  {
    actionText: 'Contact support',
    avatar: <ContactAvatar />,
    key: 2,
    to: './contact-us',
    text: "Can't find the answers you are looking for? Get in touch with our team directly during weekdays. We try our best to respond quickly.",
    title: 'Contact support',
  },
];

const HelpCenter = () => (
  <>
    <AppBar title="Help center" />
    <Breadcrumbs
      items={[{ label: 'Home', to: '/' }, { label: 'Help center' }]}
      sx={{ display: { xs: 'none', sm: 'flex' } }}
    />
    <Container>
      <Typography component="h1" variant="h3" pt={7} mb={3}>
        How can we help you?
      </Typography>
      <Typography component="p" variant="subtitle1" color="text.secondary" mb={6} fontWeight="bold">
        Lets get started by going over the basics of the ecosystem. Select one of these options to get started.
      </Typography>
      <Box display="flex" gap={3} flexDirection={{ xs: 'column', sm: 'row' }} mb={3}>
        {actions.map(option => (
          <ActionCard {...option} key={option.key} />
        ))}
      </Box>
    </Container>
  </>
);

export default HelpCenter;
